import { useAtomValue } from 'jotai';

import { ModuleBaseFloor, TableModuleGrid, useTableParameters } from '@blocks';
import { useSwingAnalyses } from '@queries';
import { Box, ClubIcon, colors, Spinner, WarningIcon, u, Heading2 } from '@ui';

import { swingsAtom } from '../../store/activity';

import * as css from './TableModule.css';

type TableModuleProps = {
    nodeId: string;
};

// const MAX_COLUMN_WIDTH = 165;

export function TableModule({ nodeId }: TableModuleProps) {
    const swings = useAtomValue(swingsAtom);
    const { isLoading: isLoadingAnalyses } = useSwingAnalyses(swings.map((swing) => swing.uuid));
    const tableParameters = useTableParameters(nodeId);

    if (isLoadingAnalyses) {
        console.warn(`isLoadingAnalyses:${isLoadingAnalyses}, swingsLength:${swings.length}`);
        return (
            <ModuleBaseFloor title={'Parameter table'}>
                <Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center">
                    <Spinner size="l" />
                </Box>
            </ModuleBaseFloor>
        );
    }

    if (tableParameters.length === 0 || swings.length === 0) {
        const msg =
            tableParameters.length === 0
                ? 'Please select parameters from the settings button above'
                : 'Waiting for swings';
        return (
            <ModuleBaseFloor title={'Parameter table'}>
                <Box display="flex" justifyContent="center" width="100%" py={u(2)}>
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="100%"
                        className={css.negativeMargin}
                    >
                        {tableParameters.length === 0 ? (
                            <WarningIcon size={u(8)} color={colors.bluegray[700]} />
                        ) : (
                            <ClubIcon width={u(8)} color={colors.bluegray[700]} />
                        )}
                        <Heading2 paddingInlineStart={u(2)}>{msg}</Heading2>
                    </Box>
                </Box>
            </ModuleBaseFloor>
        );
    }

    return (
        <ModuleBaseFloor title={'Parameter table'}>
            <Box height="min-content" position="relative">
                <TableModuleGrid nodeId={nodeId} darkMode={true} interactive={false} />
            </Box>
        </ModuleBaseFloor>
    );
}
